// extracted by mini-css-extract-plugin
export var numberInputContainer = "_75-0";
export var startPickingButton = "_75-1";